import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import { FeedSection } from "@pages/Section/utils/types";
import CardMeta from "@particles/card/components/CardMeta";
import { Section } from "@typings/Cue";
import { sectionNavigationItems } from "@util/constant";

/**
 * Helpers to get meta details for a card with section details
 * @param mainSection - The main section of the article.
 */
export const getMetaDetails = (
  section?: Section | FeedSection
): ComponentProps<typeof CardMeta> | undefined => {
  if (typeof section === "undefined") return;

  const mainSectionKey = section.uniqueName.replace("_", "/");

  return {
    text: sectionNavigationItems[mainSectionKey]?.label || section.name,
    to: RouteFactory.section(mainSectionKey),
  };
};
